import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87ea7ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-footer" }
const _hoisted_2 = {
  key: 0,
  class: "quick-questions"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "22",
    y1: "2",
    x2: "11",
    y2: "13"
  }),
  /*#__PURE__*/_createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSuggestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion) => {
            return (_openBlock(), _createElementBlock("span", {
              key: suggestion,
              class: "suggestion-chip",
              onClick: ($event: any) => (_ctx.useSuggestion(suggestion))
            }, _toDisplayString(suggestion), 9, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendAsk && _ctx.sendAsk(...args)), ["prevent"])),
      class: "input-wrapper"
    }, [
      _withDirectives(_createElementVNode("input", {
        id: "InputQuestion",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question) = $event)),
        class: "form-control",
        type: "text",
        placeholder: "Escribe tu pregunta…"
      }, null, 512), [
        [_vModelText, _ctx.question]
      ]),
      _createElementVNode("button", {
        disabled: _ctx.question.length === 0,
        type: "submit",
        class: "btn-send"
      }, _hoisted_6, 8, _hoisted_4)
    ], 32)
  ]))
}